import MxTypography from "@rf-l1/MxTypography";
import React from "react";

const TypographyOverlay = ({ text }: { text: string }) => {
  return (
    <MxTypography
      color="primary.main"
      size={18}
      align="center"
      fontWeight="bold"
      className="text-title"
    >
      {text}
    </MxTypography>
  );
};

export default TypographyOverlay;
